import { basicEnum } from "./base";

export const OLTTypeEnum = basicEnum([
    {
        label: "Huawei SmartAX MA5801",
        value: "Huawei-MA5801",
    },
]);

export namespace OLTTypeEnum {
    export type Labels = (typeof OLTTypeEnum)["labels"][number];
    export type Values = (typeof OLTTypeEnum)["values"][number];
}
